import { Alert } from 'antd'
import { useTranslation } from 'react-i18next'
import type { SubscriberState } from '@/shared/auth/authApi'

const TYPE_BY_STATE: Record<SubscriberState, 'success' | 'warning' | 'error' | 'info'> = {
  NEW: 'info',
  ACTIVE: 'success',
  SUSPENDED: 'warning',
  BLOCKED: 'error',
  CLOSED: 'error',
  UNKNOWN: 'info',
}

/**
 * Holat banneri — status va "nima qilish kerak".
 *
 * `SubscriberState` — `uz.xsib.subscriber.api.SubscriberState` (NEW/ACTIVE/
 * SUSPENDED/BLOCKED/CLOSED). Muddat tugashi bu yerda YO'Q — u endi
 * `AccessGrant` (paket) darajasida, `balance.activeGrant.expiresAt` orqali
 * (`DashboardPage.tsx`), abonent hisobining O'ZI holati emas.
 *
 * <h2>⚠️ X-SIB-001 — SABAB TAXMIN QILINMAYDI</h2>
 * Ilgari `SUSPENDED` uchun matn qat'iy shunday edi:
 * «Balansingiz tugadi. Davom etish uchun paket sotib oling.»
 *
 * Bu TAXMIN edi va u yolg'on bo'lib chiqdi: testerda 140 401 AFN va
 * 5,13 GB turgan holda ham shu matn ko'rinardi. Sababi oddiy —
 * to'xtatish sababi HECH QAYERDA saqlanmaydi. `SubscriberService.suspend`
 * `reason` argumentini oladi, lekin uni faqat AUDIT yozuviga beradi
 * (`transition(...) -> record(action, …, reason)`); `subscriber` jadvalida
 * bunday ustun yo'q. Ya'ni kabinet faqat `SUSPENDED` so'zini biladi va
 * undan sababni chiqarib bo'lmaydi.
 *
 * <p>To'xtatish esa ko'p sababdan bo'ladi: kvota tugashi
 * (`EnforcementService`), muddat, operatorning qo'lda to'xtatishi,
 * qarz. Ulardan bittasini tanlab yozish — foydalanuvchini noto'g'ri
 * ishga yo'naltirish (u paket sotib oladi, muammo esa boshqa joyda).
 *
 * <h2>Qoida</h2>
 * <ul>
 *   <li><b>Aniq FAKT bo'lsa</b> — aytiladi. Kabinet bitta faktni
 *       haqiqatan biladi: amaldagi paket bormi ({@code hasPackage}).
 *       Paket yo'q bo'lsa "paket sotib oling" — bu taxmin emas,
 *       o'lchangan holat;</li>
 *   <li><b>Fakt bo'lmasa</b> — UMUMIY matn: "to'xtatilgan, sabab bu
 *       yerda ko'rsatilmaydi, operator bilan bog'laning". Noaniq,
 *       lekin ROST.</li>
 * </ul>
 *
 * @param hasPackage amaldagi paket bormi. `undefined` — hali NOMA'LUM
 *                   (balans so'rovi tugamagan). ⚠️ `undefined` ni
 *                   `false` deb qabul qilish yuklanish paytida
 *                   "paketingiz yo'q" degan yolg'on xabarni ko'rsatardi.
 */
export function StatusBanner({
  state,
  hasPackage,
}: {
  state: SubscriberState
  hasPackage?: boolean
}) {
  const { t } = useTranslation()

  if (state === 'ACTIVE') return null

  const description =
    state === 'SUSPENDED' && hasPackage === false
      ? t('status.hint.SUSPENDED_NO_PACKAGE')
      : t(`status.hint.${state}`)

  return (
    <Alert
      type={TYPE_BY_STATE[state]}
      showIcon
      message={t(`status.${state}`)}
      description={description}
    />
  )
}
